import React, { FunctionComponent } from 'react';
import { Routes, Route } from 'react-router-dom';
import MyFooter from './components/MyFooter';
import MyHeader from './components/MyHeader';
import { Home, Preview } from './pages';
import AppContextProvider from './providers/AppContextProvider';
import ThemeContextProvider from './providers/ThemeContextProvider';

interface AppProps { }

const PageRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='preview' element={<Preview />} />
    </Routes>
  )
}

const App: FunctionComponent<AppProps> = () => {

  return (
    <ThemeContextProvider>
      <MyHeader />
      <AppContextProvider>
        <PageRoutes />
      </AppContextProvider>
      <MyFooter />
    </ThemeContextProvider>
  );
}

export default App;